import { useNavigationQueryApi } from 'graphql/generated';
import { useQueryError } from 'hooks/graphQl/UseQueryError';
import { NavigationItemType } from 'types/navigation';

export function useNavigationItems(): { navigationItems: NavigationItemType[]; fetching: boolean } {
    const [{ data, error, fetching }] = useNavigationQueryApi();
    useQueryError(error);

    const navigationItems: NavigationItemType[] = [];

    if (data?.categories === undefined) {
        return { navigationItems: [], fetching };
    }

    for (const mappedDataItem of data.categories) {
        navigationItems.push({
            ...mappedDataItem,
            categoryIcon: mappedDataItem.categoryIcon ?? null,
            // children: mapCategories(mappedDataItem.children),
        });
    }

    return { navigationItems, fetching };
}
